import { createHttpClient } from '@toggl/sync/http';

import {
  deleteAuthToken as deleteAuthTokenV2Api,
  setAuthToken as setAuthTokenV2Api,
} from '@/api/api';

const configuration: { authToken: string | null } = {
  authToken: null,
};

export function setAuthToken(authToken: string) {
  setAuthTokenV2Api(authToken);
  configuration.authToken = authToken;
}

export function deleteAuthToken() {
  deleteAuthTokenV2Api();
  configuration.authToken = null;
}

export const httpClient = createHttpClient({
  base: `${import.meta.env.VITE_API_URL}/api/v3`,
  timeoutMs: 5 * 60 * 1000, // 5 minutes
  onBeforeRequest: async (request) => {
    if (configuration.authToken) {
      request.headers.set('Authorization', `Bearer ${configuration.authToken}`);
    }
  },
});
